import { render, staticRenderFns } from "./ManufacturerSetting.vue?vue&type=template&id=e0ba3326&scoped=true"
import script from "./ManufacturerSetting.vue?vue&type=script&lang=js"
export * from "./ManufacturerSetting.vue?vue&type=script&lang=js"
import style0 from "./ManufacturerSetting.vue?vue&type=style&index=0&id=e0ba3326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ba3326",
  null
  
)

export default component.exports